module.exports = __webpack_public_path__ + "static/img/fh.294ab87.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fh.png
// module id = dI/+
// module chunks = 1